<template>
  <auth-layout>
    <auth-header title="Vacaciones Útiles UNMSM" subtitle="Inicia sesión en tu cuenta" />

    <!-- AVISO OFICIAL (VISIBLE) -->
    <p class="official-notice">
      Sistema oficial de matrícula de Vacaciones Útiles – UNMSM.
      No solicitamos información fuera del proceso institucional.
    </p>

    <ds-card :elevation="12" variant="elevated" class="login-card">
      <template #content>
        <ds-form ref="formRef" v-model="isFormValid" :show-actions="false" fields-gap="md" @submit="handleSubmit">
          <ds-text-field v-model="formData.email" label="Correo electrónico" type="email"
            placeholder="correo@ejemplo.com" prepend-inner-icon="mdi-email-outline" :rules="emailRules"
            :disabled="isLoading" ds-variant="outlined" ds-color="primary" autocomplete="email" clearable
            @blur="validateField('email')" />

          <ds-text-field v-model="formData.password" :type="showPassword ? 'text' : 'password'" label="Contraseña"
            placeholder="••••••••" prepend-inner-icon="mdi-lock-outline"
            :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'" @click:append-inner="togglePassword"
            :rules="passwordRules" :disabled="isLoading" ds-variant="outlined" ds-color="primary"
            autocomplete="current-password" @blur="validateField('password')" />

          <div class="login-card__options">
            <ds-checkbox v-model="formData.rememberMe" label="Recordar sesión" :disabled="isLoading" ds-color="primary"
              density="compact" hide-details />

            <ds-link href="#" ds-variant="bold" ds-color="accent" @click.prevent="handleForgotPassword">
              ¿Olvidaste tu contraseña?
            </ds-link>
          </div>

          <ds-button type="submit" ds-variant="primary" size="large" block :loading="isLoading"
            :disabled="!isFormValid || isLoading" class="login-card__submit">
            <template v-if="!isLoading">
              Iniciar Sesión
            </template>
            <template v-else>
              Iniciando sesión...
            </template>
          </ds-button>

          <ds-alert v-if="errorMessage" type="error" variant="tonal" :message="errorMessage" closable
            class="login-card__alert" @close="clearError" />

          <v-divider class="login-card__divider" />

          <div class="login-card__register">
            <p class="login-card__register-text">
              ¿No tienes una cuenta?
            </p>
            <ds-button :to="{ name: 'Register' }" ds-variant="secondary" size="large" block
              class="login-card__register-btn">
              Registrarse como Apoderado
            </ds-button>
          </div>
        </ds-form>
      </template>
    </ds-card>

    <auth-footer />
  </auth-layout>
</template>

<script setup lang="ts">
import { DsButton, DsTextField, DsCheckbox, DsLink } from '@/shared/components/atoms'
import { DsAlert } from '@/shared/components/molecules'
import { DsCard, DsForm } from '@/shared/components/organisms'
import { AuthLayout, AuthHeader, AuthFooter } from '@/modules/auth/components'
import { useLogin } from './LoginView'

const {
  formRef,
  formData,
  isFormValid,
  isLoading,
  showPassword,
  errorMessage,
  emailRules,
  passwordRules,
  handleSubmit,
  togglePassword,
  validateField,
  clearError,
  handleForgotPassword,
} = useLogin()
</script>

<style scoped lang="scss" src="./LoginView.scss" />
